/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ZhVideo.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

class ZhVideo extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className="ZhVideo-view">
        <Helmet>
          <title>Video - CheckPlus</title>
        </Helmet>
        <Link to="/Zh">
          <div className="ZhVideo-closeBtn" />
        </Link>

        <div className="ZhVideo-container">
          <iframe
            className="ZhVideo-iframe"
            title="Introducing CheckPlus"
            src="https://www.youtube.com/embed/gqgHB-2wutA"
            frameBorder="0"
            webkitallowfullscreen="webkitallowfullscreen"
            mozallowfullscreen="mozallowfullscreen"
            msallowfullscreen="msallowfullscreen"
            oallowfullscreen="oallowfullscreen"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    );
  }
}

export default ZhVideo;
